export enum NocturnalUrinaryFrequency {
    NEVER = 'NEVER',
    LESS_THAN_ONE = 'LESS_THAN_1_TIME',
    ONE_TO_TWO = '1_TO_2_TIMES',
    THREE_TO_FOUR = '3_TO_4_TIMES',
    FIVE_TO_SEVEN = '5_TO_7_TIMES'
}



